import { mf, msg } from '../message-functions'

/**
  <span style="color:#85c1dc;">**EE:**</span>
  Toode ei ole müügis

  <span style="color:#85c1dc;">**FI:**</span>
  Tuote ei ole myynnissä

  <span style="color:#85c1dc;">**RU:**</span>
  Изделия нет в продаже
*/
/* @__NO_SIDE_EFFECTS__ */
const m1569 = msg(
  mf`Toode ei ole müügis`,
  mf`Tuote ei ole myynnissä`,
  mf`Изделия нет в продаже`,
)

export { m1569 as 'w.toode.pole.muugis' }